"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompletedResult = exports.AbortedResult = void 0;
exports.AbortedResult = {
    isAborted: true,
};
const CompletedResult = (data) => ({
    isAborted: false,
    data,
});
exports.CompletedResult = CompletedResult;
